<template>
  <div
    class="rounded-2xl p-px bg-[linear-gradient(97.74deg,#F87E87_5.98%,#F58220_36.8%,#F32735_94.02%)] shadow-[0px_1px_4px_2px_rgba(243,39,53,0.2)]"
  >
    <div class="rounded-2xl bg-white" :class="innerClass">
      <slot />
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  innerClass?: ClassType
}>()
</script>
